import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FeatureFlagsService } from './featureFlags.service';

export interface PastDueSummary {
  count: number;
  total_amount: number;
}

@Injectable({
  providedIn: 'root',
})
export class PastDueService {
  constructor(
    private http: HttpClient,
    private featureFlagsService: FeatureFlagsService,
    private router: Router,
  ) {}

  enabled(): boolean {
    return !!this.featureFlagsService.getByEnv('ui', 'past_due_terms');
  }

  getFacilitySummary(facilityId: number | string): Observable<PastDueSummary> {
    return this.http
      .get<any>(
        `${environment.api_url_v1}/services/order/order/facility/${facilityId}/past_due_summary`,
      )
      .pipe(map(response => response.data));
  }

  // Always the pre-filtered orders LIST — that's where the buyer Pay Now buttons
  // live; the order-details page only has staff link-generation (no buyer pay).
  routeToPastDue(summary: PastDueSummary, facilityId: number | string): void {
    this.router.navigate(['/orders'], {
      queryParams: { query: 'Past Due', facility_id: facilityId },
    });
  }
}
